import { Platforms } from '../features/Platforms/models'

export const PLATFORMS_NAMES: Record<Platforms, string> = {
  meta: 'Meta',
  google: 'Google',
  microsoft: 'Microsoft',
}
